import React, { Component } from 'react'

export default class WorkProgress extends Component {
    render() {
        return (
            <div>
                <div className="brokenLink">
                    <img src={process.env.PUBLIC_URL + '/images/workProgress.png'} alt="" />
                </div>
            </div>
        )
    }
}
